<mat-drawer-container>
  <mat-drawer position="end" [opened]="!(isMobile$ | async)" [mode]="sideDrawerMode$ | async">
    <app-payments-sidebar (openedChange)="onSidebarOpenedChange($event)"></app-payments-sidebar>
  </mat-drawer>

  <mat-drawer-content [ngClass]="{ 'mobile-mat-drawer-content pb-6': isMobile$ | async }">
    <div *ngIf="!(arePayablesLoading$ | async)">
      <div *ngIf="(selectedPayables$ | async)?.length === 1; then thenBlock else elseBlock"></div>
      <ng-template #thenBlock>
        <div class="grid-cont grid-cont--xs">
          <button type="button" class="mb--150 button button--simple" (click)="onBackClicked()" data-cy="go-back">
            <svg
              viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
              stroke-linecap="round" stroke-linejoin="round" class="button__icon"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            <span>View all Invoices</span>
          </button>
          <app-single-invoice-view [invoiceTableDataObject]="(selectedPayables$ | async)[0]"></app-single-invoice-view>
        </div>
      </ng-template>
      <ng-template #elseBlock>
        <div class="grid-cont grid-cont--sm">
          <button type="button" class="mb--150 button button--simple" (click)="onBackClicked()" data-cy="go-back">
            <svg
              viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
              stroke-linecap="round" stroke-linejoin="round" class="button__icon"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            <span>View all Invoices</span>
          </button>
          <app-multi-invoice-view></app-multi-invoice-view>
        </div>
      </ng-template>
    </div>

    <!-- Make sure get invoices call completes before deciding to display empty page text -->
    <div *ngIf="arePayablesLoading$ | async" class="d-flex align-items-center justify-content-center p-12">
      <mat-spinner [diameter]="250"></mat-spinner>
    </div>

    <div *ngIf="areSelectedPayablesEmpty$ | async" class="d-flex flex-column align-items-stretch">
      <div *ngIf="isReviewAndPayEmptyStateMessageEnabled$ | async" class="alert d-flex flex-column gap-4 mx-6">
        <p>
          You received a statement this morning that contained inaccurate invoice information.
          We sincerely apologize for any confusion this may have caused.
          Your portal reflects the true amount of any outstanding balances.
        </p>

        <p>
          No action is needed on your part, but please do not hesitate to reach out to us at
          <a href="mailto:support@aiwyn.ai">support&#64;aiwyn.ai</a> and/or the Windes Central Billing Group at
          <a href="mailto:CentralizedBillingGroup@windes.com">CentralizedBillingGroup&#64;windes.com</a> with any additional questions.
        </p>
      </div>

      <app-empty-page
        *ngIf="reviewAndPayZeroState$ | async as zeroState"
        [text]="zeroState.text"
        [title]="zeroState.title"
      ></app-empty-page>
    </div>

    <app-client-portal-footer class="mt-4"></app-client-portal-footer>
  </mat-drawer-content>
</mat-drawer-container>

<div
  *ngIf="configService.isMobile && !(isSideDrawerOpen$ | async)"
  class="footbar"
  [ngClass]="{ 'active' : (selectedPayables$ | async)?.length !== 0 }"
>
  <div class="grid-row grid-row--nog">
    <div class="grid-col">
      <button
        andButton
        color="primary"
        size="large"
        [disabled]="(selectedPayables$ | async)?.length === 0"
        (click)="openSidebar()"
        class="w-100"
        data-cy="open-sidebar"
      >
        <span>Go to Payment</span>
        <svg
          viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
          stroke-linecap="round" stroke-linejoin="round" class="button__icon"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div>
</div>
